
import { Button, DataGrid, RadioGroup, SelectBox } from "devextreme-react";
import React, { useCallback, useEffect, useState } from "react";
import { ApproverTypes, lookupGroups } from "../../../../../utils/lookup-groups.ts";
import { useLookupGroup } from "../../../../../contexts/lookup-group-context";
import { Column, Editing, Item, Lookup, RequiredRule, Toolbar } from "devextreme-react/cjs/data-grid";
import { getDataGridCustomToolbarCaption } from "../../../../../components/default-components/data-grid-custom-toolbar.js";
import "./approve-hierarchy-step.css"

function ApproveHierarchyStepTmplate(approverValueList, willBeNotifiedList, setDirty, removeStep) {

    return function F(data) {
        const [multiapprovalTypes, setMultiapprovalTypes] = useState([])
        const [approversCount, setApproversCount] = useState(data.approveHierarchyStepApprovers?.length ?? 0)
        const [notifiedsCount, setNotifiedsCount] = useState(data.approveHierarchyStepWillBeNotifieds?.length ?? 0)
        const [approverTypes, setApproverTypes] = useState()
        const [willBeNotifiedTypes, setWillBeNotifiedTypes] = useState()

        const { getLookupData } = useLookupGroup()

        useEffect(() => {
            getLookupData(lookupGroups.approverTypes).then(response => setApproverTypes(response))
            getLookupData(lookupGroups.multiApprovalTypes).then(response => setMultiapprovalTypes(response))
            getLookupData(lookupGroups.willBeNotifiedTypes).then(response => setWillBeNotifiedTypes(response))
        }, [])

        function setStateValue(rowData, value) {
            rowData.approverTypeValueId = null;
            this.defaultSetCellValue(rowData, value);
        }

        function setNotifiedsStateValue(rowData, value) {
            rowData.willBeNotifiedTypeValueId = null;
            this.defaultSetCellValue(rowData, value);
        }

        const onEditorPreparing = (e) => {
            if (e.parentType === 'dataRow' && e.dataField === 'approverTypeValueId') {
                const isStateNotSet = e.row.data.approverTypeId === undefined;
                e.editorOptions.disabled = isStateNotSet;
            }
        };
        //approveHierarchyStepWillBeNotifieds
        const onNotifiedsEditorPreparing = (e) => {
            if (e.parentType === 'dataRow' && e.dataField === 'willBeNotifiedTypeValueId') {
                const isStateNotSet = e.row.data.willBeNotifiedTypeId === undefined;
                e.editorOptions.disabled = isStateNotSet;
            }
        };

        const getFilteredApprovers = (options) => (
            {
                store: approverValueList,
                filter: options.data ? ['approverTypeId', '=', options.data.approverTypeId] : null,
            });
        const getFilteredNotifieds = (options) => (
            {
                store: willBeNotifiedList,
                filter: options.data ? ['willBeNotifiedTypeId', '=', options.data.willBeNotifiedTypeId] : null,
            });

        const handleContentReady = (e) => {
            setApproversCount(e.component.totalCount())
        }
        const handleNotifiedsContentReady = (e) => {
            setNotifiedsCount(e.component.totalCount())
        }

        const onMultiApprovalTypeChanged = useCallback((e) => {
            data.multiApprovalTypeId = e.value
            setDirty(true)
        }, [])

        const onRemoveStepClick = useCallback((e) => {
            if (data.step)
                removeStep(data.step)
        }, [removeStep])

        const handleInitNewRow = (e) => {
            if (data.id)
                e.data.approveHierarchyStepId = data.id; // aktif kaydın approveHierarchyStepId alanını doldur
        };

        return (
            <div>
                <div>
                    <DataGrid
                        dataSource={data.approveHierarchyStepApprovers}
                        onEditorPreparing={onEditorPreparing}
                        twoWayBindingEnabled={true}
                        onContentReady={handleContentReady}
                        showBorders={true}
                        onInitNewRow={handleInitNewRow}
                        onRowInserted={() => { setDirty(true) }}
                        onRowRemoved={() => { setDirty(true) }}
                    >
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("Onaylayanlar")}
                            <Item name="addRowButton" />
                        </Toolbar>


                        <Editing
                            allowAdding={true}
                            allowDeleting={true}
                        />
                        <Column
                            dataField="approverTypeId"
                            setCellValue={setStateValue}
                            caption="Onaylayan Türü"
                        >
                            <Lookup
                                dataSource={approverTypes}
                                displayExpr="text"
                                valueExpr="id" />
                            <RequiredRule />
                        </Column>
                        <Column
                            dataField="approverTypeValueId"
                            caption="Onaylayan"
                        >
                            <Lookup
                                dataSource={getFilteredApprovers}
                                displayExpr="text"
                                valueExpr="id"
                            />
                            <RequiredRule />

                        </Column>
                    </DataGrid>
                </div>
                {
                    (approversCount > 1)
                    &&
                    <RadioGroup
                        items={multiapprovalTypes}
                        valueExpr="id"
                        displayExpr="text"
                        layout="horizontal"
                        defaultValue={data.multiApprovalTypeId}
                        style={{ marginTop: "10px" }}
                        onValueChanged={onMultiApprovalTypeChanged}
                    />

                }

                <DataGrid
                    dataSource={data.approveHierarchyStepWillBeNotifieds}
                    onEditorPreparing={onNotifiedsEditorPreparing}
                    twoWayBindingEnabled={true}
                    onContentReady={handleNotifiedsContentReady}
                    showBorders={true}
                    onInitNewRow={handleInitNewRow}
                    onRowInserted={() => { setDirty(true) }}
                    onRowRemoved={() => { setDirty(true) }}
                >
                    <Toolbar>
                        {getDataGridCustomToolbarCaption("Bilgilendirilecekler")}
                        <Item name="addRowButton" />
                    </Toolbar>


                    <Editing
                        allowAdding={true}
                        allowDeleting={true}
                    />
                    <Column
                        dataField="willBeNotifiedTypeId"
                        setCellValue={setNotifiedsStateValue}
                        caption="Bilgilendirilen Türü"
                    >
                        <Lookup
                            dataSource={willBeNotifiedTypes}
                            displayExpr="text"
                            valueExpr="id" />
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="willBeNotifiedTypeValueId"
                        caption="Bilgilendirilen"
                    >
                        <Lookup
                            dataSource={getFilteredNotifieds}
                            displayExpr="text"
                            valueExpr="id"
                        />
                        <RequiredRule />

                    </Column>
                </DataGrid>

                <Button className="remove-step dx-primary" text="Bu Adımı Kaldır" onClick={onRemoveStepClick} />


            </div>
        )
    }
}

export default ApproveHierarchyStepTmplate